import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Plus = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-minus-icon lucide-minus'
      >
        <path d='M5 12h14' />
      </svg>
    </SvgIcon>
  );
};

export default Plus;
